module.exports = __webpack_public_path__ + "static/hulu-e18fcd1184a531acbccb08e3c0b480ab.png";